import apiService from '@sonifi/wb-core/services/api.service';
import { ENDPOINTS } from '@sonifi/wb-core/services/endpointsConstants';
import {
  getIdFromUrl,
  parseQueryParams,
} from '@sonifi/wb-core/utils/parseHelper';
import { buildImagesParam } from './helpers/irdMenuRequestsHelper';

const optionsSetsDependenciesNoRepeated = (optionSetsDependencies) => {
  const osDepNoRepeated = [];

  for (const osd of optionSetsDependencies) {
    if (!osDepNoRepeated.some((od) => od.uri === osd.uri)) {
      osDepNoRepeated.push(osd);
    }
  }

  return osDepNoRepeated;
};

export const getIrdOptionsSetsDependencies = ({
  irdItems,
  currentOptionSetsDependencies,
}) => {
  const optionSets = [];

  for (const item of irdItems) {
    optionSets.push(
      ...item.subject.ird_option_sets
        .filter(
          (osUri) =>
            !currentOptionSetsDependencies.some((osd) => osd.uri === osUri)
        )
        .map((osUri) => ({
          id: getIdFromUrl({ url: osUri, parseToInt: true }),
          uri: osUri,
        })),
    );
  }
  const osDepNoRepeated = optionsSetsDependenciesNoRepeated(optionSets);
  return osDepNoRepeated;
};

export const getMediaDependencies = async ({ group, imgData }) => {
  try {
    const params = {
      group: group.uri,
      id__in: buildImagesParam(imgData),
      rpp: -1,
    };
    const url = `${ENDPOINTS.IMAGES}?${parseQueryParams(params)}`;
    const res = await apiService.get(url);
    const mediaDependencies = res.data.objects.map((media) => ({
      ...media,
      files: media.files.map((file) => res.data._embedded[file]),
    }));

    return mediaDependencies;
  } catch (error) {
    return [];
  }
};

export const getOptionSetsDependencies = async (optionSets) => {
  const optionSetsDependencies = [];
  try {
    const promises = [];
    for (const os of optionSets) {
      promises.push(apiService.get(`${ENDPOINTS.IRD_OPTION_SETS}/${os.id}`));
    }
    const res = await Promise.all(promises);
    optionSetsDependencies.push(...res.map((r) => r.data));
    return optionSetsDependencies;
  } catch (error) {
    return optionSetsDependencies;
  }
};
